import { isProduction } from './platform';
import { getQuery, rangeIsLastare } from './queryUtils';
const TTL = 36000000; // 10 hours in ms.
export const PROXY_QUERY_PARAM = 'proxyToken';
export const PROXY_STORAGE_KEY = 'storageone-proxy-token';
export const getStoredToken = () => {
    const storedValue = localStorage.getItem(PROXY_STORAGE_KEY);
    if (!storedValue)
        return null;
    return JSON.parse(storedValue);
};
export const shouldUseProxyToken = () => !isProduction() && hasStoredToken() && rangeIsLastare();
export const hasStoredToken = () => !!localStorage.getItem(PROXY_STORAGE_KEY);
export const isTokenValid = () => (getStoredToken()?.expiresAt ?? 0) > Date.now();
export const removeStoredToken = () => localStorage.removeItem(PROXY_STORAGE_KEY);
export const extractAndStoreToken = () => {
    if (!getQuery().has(PROXY_QUERY_PARAM))
        return;
    const token = getQuery().get(PROXY_QUERY_PARAM);
    if (!token)
        return;
    localStorage.setItem(PROXY_STORAGE_KEY, JSON.stringify({ token, expiresAt: Date.now() + TTL }));
};
export const sanitizeUrl = () => {
    if (!getQuery().has(PROXY_QUERY_PARAM))
        return;
    const url = new URL(window.location.href);
    url.searchParams.delete(PROXY_QUERY_PARAM);
    window.history.replaceState({}, '', url.toString());
};
//# sourceMappingURL=proxyTokenUtils.js.map